/**
 * Axios 配置
 * 自動添加 JWT token 到所有請求
 */
import axios from 'axios';
import JWTManager from './JWTManager';

// 請求攔截器 - 添加 Authorization header
axios.interceptors.request.use(
  async (config) => {
    // 獲取 token
    const token = JWTManager.getAccessToken();
    
    // 如果 token 即將過期且有 refresh token，嘗試刷新
    if (token && JWTManager.isTokenExpiringSoon() && JWTManager.getRefreshToken()) {
      try {
        await JWTManager.refreshToken();
      } catch (error) {
        console.warn('[Axios] Token refresh failed:', error);
      }
    }
    
    // 添加 Authorization header
    const currentToken = JWTManager.getAccessToken();
    if (currentToken) {
      config.headers['Authorization'] = `Bearer ${currentToken}`;
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 響應攔截器 - 處理 401 錯誤
axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    
    // 如果是 401 錯誤且沒有重試過
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      
      // 嘗試刷新 token
      if (JWTManager.getRefreshToken()) {
        try {
          await JWTManager.refreshToken();
          
          // 重試原請求
          const token = JWTManager.getAccessToken();
          originalRequest.headers['Authorization'] = `Bearer ${token}`;
          return axios(originalRequest);
        } catch (refreshError) {
          console.error('[Axios] Token refresh failed:', refreshError);
          
          // 清除 token 並觸發重新登入
          JWTManager.clearToken();
          window.dispatchEvent(new CustomEvent('tokenExpired'));
          
          return Promise.reject(refreshError);
        }
      }
    }
    
    return Promise.reject(error);
  }
);

export default axios;


